import React, { Component } from "react";
import _ from 'lodash';

const RE_NAME_TEXT = 'Rename To';
const COPY_TEXT = 'Copy To';

export default class File extends Component{
  constructor(props) {
    super(props);

    this.state = {
      class: props.class ? props.class : '',
      file: props.file,
      showDropdown: false,
    };

    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.toggleRename = this.toggleRename.bind(this);
    this.onRename = this.onRename.bind(this);
    this.onCopy = this.onCopy.bind(this);
    this.handleRenameChange = this.handleRenameChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  getFileType(file) {
    const parts = file.split('.');
    return _.last(parts);
  }

  getIconClass(file) {
    const type = this.getFileType(file);

    switch (type) {
      case 'pdf':
        return 'fa-file-pdf-o';
      case 'png':
      case 'jpeg':
      case 'gif':
      case 'jpg':
        return 'fa-file-image-o';
      case 'doc':
      case 'docx':
        return 'fa-file-word-o';
      case 'xls':
      case 'xlxs':
        return 'fa-file-excel-o';
      default:
        return 'file';
    }
  }

  toggleDropdown(e) {
    e.preventDefault();
    this.setState({showDropdown: !this.state.showDropdown});
  }

  toggleRename(text) {
    this.setState({showRename: !this.state.showRename, renameText: text});
    // turn off dropdown
    if (this.state.showDropdown) {
      this.setState({showDropdown: false})
    }
  }

  handleClick(e) {
    if (this.state.renameText === RE_NAME_TEXT) {
      this.onRename();
    } else {
      this.onCopy();
    }
  }

  onRename() {
    this.props.onRename(this.state.file.path, this.state.reNameTo);
  }

  onCopy() {
    this.props.onCopy(this.state.file.path, this.state.reNameTo);
  }

  handleRenameChange(event) {
    this.setState({reNameTo: event.target.value});
  }

  render() {
    const { isCustomerView } = this.props;
    let tableClass = this.state.showRename ? "selected clickable folder" : "clickable folder";
    if (this.props.class) {
      tableClass += ' ' + this.props.class
    }

    const fileClass = 'file-icon fa ' + this.getIconClass(this.state.file.path) + ' fa-1x fa-fw';
    return (
      <tr className={tableClass}>
        <td>
          <i className={fileClass}></i>
          <span
            className={this.state.showRename ? 'hide' : 'show'}
            onClick={() => this.props.onClick(this.state.file)}
          >
            {this.state.file.name}
          </span>
          <span className={this.state.showRename ? 'rename show selected' : 'rename hide'}>
            <input
              type="text"
              onChange={this.handleRenameChange}
              placeholder={this.state.renameText}
            />
            <button onClick={this.handleClick} className="btn">Save</button>
            <button onClick={this.toggleRename} className="btn">Cancel</button>
          </span>
        </td>
        <td data-role="menu">
          {!isCustomerView && <div className={this.state.showDropdown ? "menu open" :"menu"}>
            <span className="menu-button" onClick={this.toggleDropdown}><i className="fa fa-ellipsis-h"></i></span>
            <ul>
              <li onClick={() => this.toggleRename(RE_NAME_TEXT)}>
                Rename
              </li>
              <li onClick={() => this.toggleRename(COPY_TEXT)}>
                Make a Copy
              </li>
              <li onClick={() => this.props.onDelete(this.state.file.path)}>
                Delete
              </li>
            </ul>
          </div>}
        </td>
      </tr>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/File.js